export default function(params, node){
  var self = this;

  self.$el = $(node);
  self.articles = ko.observableArray();
  self.searchQuery = ko.observable();
  self.selectedSort = ko.observable();
  self.pagination = ko.observable();

  self.sortOptions = ko.observableArray([
    { id: 1, name: 'Newest', param: 'created_at', direction: 'desc'  },
    { id: 2, name: 'Oldest', param: 'created_at', direction: 'asc'  }
  ]);

  self.selectedSort.subscribe(function(value) {
    var option = _.find(self.sortOptions(), function(opt) { return opt.id == value; });
    self.filterChanged(self, option);
  });

  self.init = function() {
    self.bindData(params);
    Kadenze.PaginationBinding.applyBindingsWithTextInput(self.request);
  };

  self.initUI = function() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(self.request);
  };

  self.filterChanged = function(vm, sortOption) {
    //
    // TODO: Replace with Kadenze.Routes.admin_articles_path,
    // rake isn't generating this route
    //
    var requestURL = '/admin/articles',
      data = {
        q: vm.searchQuery(),
        sort: sortOption.param,
        direction: sortOption.direction
      };

    self.request(requestURL, data);
  };

  self.request = function(url, params) {
    var request = new Kadenze.AjaxRequest({
      url: url,
      type: 'GET',
      dataAsJSON: false,
      data: params,
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(response) {
      self.bindData(response);
    });

    request.fail(self.fail);
  };

  self.delete = function(article) {
    Kadenze.UIUtil.confirmAction(Kadenze.I18n.t('notice.delete_article'), function() {

      var request = new Kadenze.AjaxRequest({
        type: 'DELETE',
        url: '/admin/articles/' + article.id(),
        loadingIndicator: {
          container: self.$el
        }
      });

      request.done(function(data) {
        self.articles.remove(article);
        new Kadenze.Notice.success({ message: 'Article deleted' });
      });

      request.fail(self.fail);
    });

  };

  self.update = function(article) {
    var request = new Kadenze.AjaxRequest({
      type: 'PUT',
      url: '/admin/articles/' + article.id(),
      data:  { article: ko.mapping.toJS(article) },
      loadingIndicator: {
        container: self.$el
      }
    });

    request.done(function(data) {
      var newArticle = ko.mapping.fromJS(data.article);

      article.featured(newArticle.featured());

      new Kadenze.Notice.success({ message: 'Article updated' });
    });

    request.fail(self.fail);
  };

  self.fail = function(data) {
    console.warn('Failed to save article:', data);
    new Kadenze.Notice.error({ message: data.responseJSON.message });
  };

  self.bindData = function(data) {
    try {
      self.json = JSON.parse(data);
    } catch (e) {
      self.json = data;
    }

    var mapped_articles = ko.mapping.fromJS(self.json.articles);

    self.articles(mapped_articles());
    self.pagination(self.json.pagination);
  };

  self.init();

  return self;
}

